import * as THREE from 'three';

export class GameScene {
  readonly scene: THREE.Scene;
  private readonly ambientLight: THREE.AmbientLight;
  private readonly dirLight: THREE.DirectionalLight;

  constructor(backgroundColor: number) {
    this.scene = new THREE.Scene();
    this.scene.background = new THREE.Color(backgroundColor);

    this.ambientLight = new THREE.AmbientLight(0xffffff, 0.6);
    this.dirLight = new THREE.DirectionalLight(0xffffff, 0.8);
    this.dirLight.position.set(5, 10, 5);

    this.scene.add(this.ambientLight);
    this.scene.add(this.dirLight);
  }

  add(obj: THREE.Object3D): void {
    this.scene.add(obj);
  }

  remove(obj: THREE.Object3D): void {
    this.scene.remove(obj);
  }

  dispose(): void {
    this.scene.clear();
  }
}
